import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const notificationCenterApi = {
  getWhatsAppStatus: () =>
    axiosClient.get(ENDPOINTS.notifications.whatsappStatus).then(unwrap),
  connectWhatsApp: () =>
    axiosClient.post(ENDPOINTS.notifications.whatsappConnect).then(unwrap),
  getWhatsAppQr: () =>
    axiosClient.get(ENDPOINTS.notifications.whatsappQr).then(unwrap),
  disconnectWhatsApp: () =>
    axiosClient.post(ENDPOINTS.notifications.whatsappDisconnect).then(unwrap),
  getWhatsAppGroups: () =>
    axiosClient.get(ENDPOINTS.notifications.whatsappGroups).then(unwrap),
  syncWhatsAppGroups: () =>
    axiosClient.post(ENDPOINTS.notifications.whatsappGroupsSync).then(unwrap),
  getNotificationRules: () =>
    axiosClient.get(ENDPOINTS.notifications.notificationRules).then(unwrap),
  getNotificationRule: (eventType) =>
    axiosClient.get(ENDPOINTS.notifications.notificationRule(eventType)).then(unwrap),
  updateNotificationRule: (eventType, data) =>
    axiosClient.put(ENDPOINTS.notifications.notificationRule(eventType), data).then(unwrap),
  getRuleDestinations: (ruleId) =>
    axiosClient.get(ENDPOINTS.notifications.ruleDestinations(ruleId)).then(unwrap),
  addRuleDestination: (ruleId, data) =>
    axiosClient.post(ENDPOINTS.notifications.ruleDestinations(ruleId), data).then(unwrap),
  removeRuleDestination: (destinationId) =>
    axiosClient.delete(ENDPOINTS.notifications.notificationDestination(destinationId)).then(unwrap),
  getNotificationOutbox: ({ page = 0, size = 25 } = {}) =>
    axiosClient.get(ENDPOINTS.notifications.notificationOutbox, { params: { page, size } }).then(unwrap),
  retryNotificationOutbox: (id) =>
    axiosClient.post(ENDPOINTS.notifications.notificationRetry(id)).then(unwrap),
  resendNotificationOutbox: (id, requestKey) =>
    axiosClient.post(ENDPOINTS.notifications.notificationResend(id), null, {
      headers: { "Idempotency-Key": requestKey },
    }).then(unwrap),
};
